import * as React from "react";
import Typography from "@mui/material/Typography";
import Timeline from '@mui/lab/Timeline';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';

import { BsPlusLg } from 'react-icons/bs'
import { Menu } from "@mui/material";
import { useSelector } from "react-redux";
import { useAddCustomerJourneyMutation, useGetCustomerJourneysActiveQuery, useUpdateCustomerJourneyMutation } from "../../../Service/CustomerJourney";
import { specialChractorValidation } from "./Utils/validation";


export default function CustomerJourney(props) {
  const { callBackforErrorMessage, openSnackBar,id } = props
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [filteredItems, setFilteredItems] = React.useState(null);
  const CustomerDetail = useSelector((state: any) => state.customer.customerDetail);
  const CustomerJourney = useSelector((state: any) => state.customer.customerJourney);
  const CustomerJourneyTypes = useSelector((state: any) => state.dashboard.customerJourney);
 const {data:response}=useGetCustomerJourneysActiveQuery();
  const [addCustomerJourney] = useAddCustomerJourneyMutation();
  const open = Boolean(anchorEl);
  const Contact = useSelector((state: any) => state.customer.customerContact);

// console.log(response);
// console.log(CustomerDetail);
// console.log(Contact?.phone1);


// console.log(CustomerJourneyTypes);
function getRandomLightColor() {
  const red = Math.floor(Math.random() * 110) + 130; // Range: 100-250
  const green = Math.floor(Math.random() * 110) + 130; // Range: 100-250
  const blue = Math.floor(Math.random() * 110) + 130; // Range: 100-250

  const color = (red * 65536 + green * 256 + blue).toString(16);

  return '#' + '0'.repeat(6 - color.length) + color;
}

  const view = window.location.pathname.split("/")[2] ==="customerview" ;


// 
// console.log("response",response);
  const transformedData = [];

for (let i = 0; i < response?.data.length; i++) {
  const stage = response?.data[i];
      transformedData.push({
        "id": stage.id,
        "name":  stage.customerJourneyName,
        
        "description": stage.description,
        "others": getRandomLightColor(), // Assigning a random color
        "mode": "customer_journey",
        "status": stage.activeStatus,
        "comments": null,
        "createdBy": null,
        "updatedBy": null,
        "createdAt": stage.createdAt,
        "updatedAt": stage.updatedAt
      });
    
  
}

// console.log("result",transformedData);

// 

  function filterByValue(array, string) {
    return array.filter(o => o.name.toLowerCase().includes(string.toLowerCase()));
  }

  const onChangeText = (text) => {
    if (text.trim().length === 0) {
      setFilteredItems(null)
    }
    else {
      setFilteredItems(filterByValue(CustomerJourneyTypes, text))
    }
  }

  const handleItemClick = async(item) => {
    if (CustomerDetail.customerName.trim().length && !specialChractorValidation(CustomerDetail.customerName)) {
      if (CustomerDetail.id && Contact?.phone1) {
        try{
        const payload = await addCustomerJourney({
          "customerId": CustomerDetail.id,
          "customerJourneyOption": item.name
        }).unwrap();
        openSnackBar("Added succesfully");
      // console.log("errrgfhgrrr",payload);


      }
      catch(err:any){
      // console.loggggg("errrrrr",err);
        openSnackBar(err.data.error,"error");

        
      }

      }
      else {
        if(!Contact?.phone1){
        openSnackBar("Please add phone number","error");
      }


      }
    }
    else {
      openSnackBar(callBackforErrorMessage(), "error")
    }
    setAnchorEl(null);
  }

  return (
    <>
      <div className="mb-2">
        <span className="title">Customer Journey *</span>
        {!view &&(   <button
          id="btn-blue"
          onClick={(e) => setAnchorEl(e.currentTarget)}
          disabled={view}
        >
          <BsPlusLg />
        </button>)}
      </div>
      <Timeline sx={{
        [`& .${timelineItemClasses.root}:before`]: {
          flex: 0,
          padding: 0,
        },
      }}>
        {CustomerJourney.map((item, index) => (
          <TimelineItem key={index}>
            <TimelineSeparator>
              <TimelineDot color={index === 0 ? "success" : "primary"} />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
              <Typography variant="subtitle1">
                {item?.customerJourneyOption}
              </Typography>
              <Typography variant="caption">{new Date(item?.createdAt).toLocaleDateString('en-GB', {
                day: 'numeric', month: 'short', year: 'numeric'
              })}</Typography>
            </TimelineContent>
          </TimelineItem>
        ))}


      </Timeline>

      <Menu
        id="fade-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        style={{ padding: '10px' }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <input
          type="text"
          className="text-custom-tag"
          placeholder="Search for an option"
          style={{ width: "95%" }}
          onChange={(e) => onChangeText(e.target.value)}
        />
        <ul className="tag-ul">
          {/* <li><small>Select an option or create one</small></li> */}
          {transformedData ? transformedData.map((item, i) => (
            <li key={i}
              onClick={() => handleItemClick(item)}
            >
              <img
                src={require("../../../assets/DigitalMarketing/image/customer/tag.png")}
                width="8"
              />
              &nbsp;
              <span style={{ background: item.others }} className={`tile-tag Thyroid cursor ${item.name.split(" ")[0]}`}>
                {item.name}
              </span>

            </li>
          ))
            :
            CustomerJourneyTypes.map((item, i) => (
              <li key={i}
                onClick={() => handleItemClick(item)}
              >
                <img
                  src={require("../../../assets/DigitalMarketing/image/customer/tag.png")}
                  width="8"
                />
                &nbsp;
                <span style={{ background: item.others }} className={`tile-tag Thyroid cursor ${item.name.split(" ")[0]}`}>
                  {item.name}
                </span>

              </li>
            ))
          }
        </ul>
      </Menu>
    </>
  );
}
